// We have completely removed the WISHLIST_KEY variable to prevent ANY scope collisions.

function getWishlist() {
  // Hardcoded the string directly here
  return JSON.parse(localStorage.getItem('shopify_wishlist')) || [];
}

function updateWishlist(handle) {
  let wishlist = getWishlist();
  const index = wishlist.indexOf(handle);
  
  if (index > -1) {
    wishlist.splice(index, 1); // Remove if exists
  } else {
    wishlist.push(handle); // Add if new
  }
  
  // Hardcoded the string directly here
  localStorage.setItem('shopify_wishlist', JSON.stringify(wishlist));
  initWishlistButtons(); // Refresh UI
  updateWishlistCount();
}

function initWishlistButtons() {
  const wishlist = getWishlist();
  const buttons = document.querySelectorAll('.wishlist-button');
  
  buttons.forEach(btn => {
    const handle = btn.getAttribute('data-product-handle');
    if (wishlist.includes(handle)) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });
}

function updateWishlistCount() {
  const wishlist = JSON.parse(localStorage.getItem('shopify_wishlist')) || [];
  const countBadge = document.getElementById('wishlist-count');
  
  if (countBadge) {
    const count = wishlist.length;
    countBadge.textContent = count;
    countBadge.setAttribute('data-count', count); // Used for the CSS "hide if 0" rule
  }
}

async function renderWishlist() {
  const container = document.getElementById('wishlist-grid');
  const emptyState = document.getElementById('wishlist-empty-state');
  const wishlist = getWishlist();

  if (!container) return; // Only run on the wishlist page

  if (wishlist.length === 0) {
    container.style.display = 'none';
    emptyState.style.display = 'block';
    return;
  }

  // Fetch all product data in parallel
  const promises = wishlist.map(handle => 
    fetch(`/products/${handle}.js`)
      .then(res => res.ok ? res.json() : null)
      .catch(() => null)
  );

  const products = await Promise.all(promises);
  container.innerHTML = ''; // Remove the loader

  products.forEach(product => {
    if (!product) return; // Skip if product doesn't exist anymore

    const productHTML = `
      <div class="grid__item">
        <div class="wishlist-card">
          <a href="${product.url}" class="full-unstyled-link">
            <img src="${product.featured_image}" alt="${product.title}" loading="lazy">
            <h3>${product.title}</h3>
            <div class="price">${(product.price / 100).toFixed(2)} ${window.Shopify.currency.active}</div>
          </a>
          <button class="remove-wishlist" onclick="removeFromWishlist('${product.handle}')">
            Remove
          </button>
        </div>
      </div>
    `;
    container.innerHTML += productHTML;
  });
}

// Global function to remove item and refresh the specific page
window.removeFromWishlist = function(handle) {
  updateWishlist(handle); 
  renderWishlist();       
};

// --- THE SAFETY LOCK ---
if (!window.WishlistListenersAttached) {
  window.WishlistListenersAttached = true;

  // Event Listener for adding/removing items
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.wishlist-button');
    if (btn) {
      e.preventDefault(); // CRITICAL: Stops the page from jumping or reloading
      const handle = btn.getAttribute('data-product-handle');
      if (handle) {
        updateWishlist(handle);
        updateWishlistCount();
      }
    }
  });

  // Initialize UI on page load
  document.addEventListener('DOMContentLoaded', () => {
    initWishlistButtons();
    renderWishlist();
  });
}